export default __webpack_public_path__ + "static/willhaben-af6b8f1275e9c6a2169d28725b170816.png";